var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-loading"}},[_c('div',{staticClass:"progress",attrs:{"id":"progress"}},[_c('span',{attrs:{"id":"progress-span"}})]),_c('p',{attrs:{"id":"loading-text"}},[_vm._v("加载中...")])])
}]

export { render, staticRenderFns }